import React, { useState, useEffect } from "react";

import "./more-like-this-widget.m.css";

const MoreLikeThisWidget = (props) => {
  const [allStories, setAllStories] = useState([]);

  useEffect(() => {
    if (allStories.length === 0) {
      (async () => {
        const storyId = props.story.id;
        const response = await (
          await fetch(`/api/v1/stories/${storyId}/related-stories?limit=5`)
        ).json();
        setAllStories(response["related-stories"]);
      })();
    }
  }, []);

  return (
    <React.Fragment>
      {allStories?.length > 0 && (
        <>
          {props.type === "premium" ? (
            <div styleName="premium-wrapper">
              <div styleName="more-like-this-heading">
                <img
                  src="/images/red-lines.svg"
                  alt="red-lines"
                  styleName="red-lines"
                />
                <h4 styleName="heading premium-heading">NEWS FOR YOU</h4>
                <img
                  src="/images/red-lines.svg"
                  alt="red-lines"
                  styleName="red-lines"
                />
              </div>
              <div styleName="section">
                {allStories.map((story, index) => (
                  <div styleName="story premium-story" key={index}>
                    <a href={`/${story.slug}`} styleName="item">
                      <div styleName="image-container" className="mobile-only">
                        <img
                          styleName="thumbnail"
                          src={
                            "https://gumlet.assettype.com/" +
                            story["hero-image-s3-key"]
                          }
                          alt={story.headline}
                        />
                      </div>
                      <h5 styleName="text">{story.headline}</h5>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div styleName="more-like-this-wrapper">
              <div styleName="more-like-this-heading">
                <img src="/images/red-lines.svg" alt="red-lines" />
                <h4 styleName="heading">MORE LIKE THIS</h4>
                <img src="/images/red-lines.svg" alt="red-lines" />
              </div>
              <div styleName="section">
                {allStories.map((story, index) => (
                  <div styleName="story" key={index}>
                    <a href={`/${story.slug}`} styleName="item">
                      <div styleName="image-container">
                        <img
                          styleName="thumbnail"
                          src={
                            "https://gumlet.assettype.com/" +
                            story["hero-image-s3-key"]
                          }
                          alt={story.headline}
                        />
                      </div>
                      <h5 styleName="text">{story.headline}</h5>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </React.Fragment>
  );
};

export default MoreLikeThisWidget;
